"use strict";

exports.__esModule = true;
exports.default = void 0;
var _default = exports.default = {
  strings: {
    revert: 'Reset',
    rotate: 'Rotate 90°',
    zoomIn: 'Zoom in',
    zoomOut: 'Zoom out',
    flipHorizontal: 'Flip horizontally',
    aspectRatioSquare: 'Crop square',
    aspectRatioLandscape: 'Crop landscape (16:9)',
    aspectRatioPortrait: 'Crop portrait (9:16)'
  }
};